import React, {useRef, useEffect} from "react";
import { useLocation } from 'react-router-dom';

export const Products = ({products}) => {

  const ScrollToAnchor = () => {
    const location = useLocation();
    const lastHash = useRef('');
    if (location.hash) {
      lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
    }

    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        document.getElementById(lastHash.current)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        lastHash.current = '';
      }, 100);
    }
  
    return null;
  };

  ScrollToAnchor();

  return (
    <>
      <div className="products">
        <div className="container">
          {products.length > 0 ? products.map((item, i) => {
            return (
              <div key={i} className="product" id={`prodotto-${i}`}>
                <div className="image">
                  <img width="400" height="400" src={require(`./../../../../assets/img/${item?.img}`)} alt="" />
                </div>
                <div className="info">
                  <div className="counter">{i + 1}</div>
                  <div className="title">{item?.titolo}</div>
                  <div className="description">{item?.descrizione}</div>
                  <div className="linkContainer">
                    <a className="amazonLink" target="_blank" rel="noreferrer" href={item?.link}>
                      <i className="icon-amazon"></i>
                      <span>Acquista su Amazon</span>
                    </a>
                  </div>
                  <div className="disclaimer-link">
                    <span>
                      <b>Nota:</b> Questo è un link di affiliazione Amazon. 
                      <br />
                      Se acquisti tramite questo link, potremmo ricevere una commissione, senza costi aggiuntivi per te.
                    </span>
                  </div>
                </div>
              </div>
            );
          }) : (
            <div className="emptyState">
              Non ci sono prodotti
            </div>
          )}
        </div>
      </div>
    </>
  );
};